var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorageReports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#storage-reports_svg__clip0_18_77793)",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.375 19.708c0 .917-.75 1.667-1.667 1.667H4.292c-.917 0-1.667-.75-1.667-1.667V4.292c0-.917.75-1.667 1.667-1.667h15.416c.917 0 1.667.75 1.667 1.667v15.416z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.208 17.375c0 .5-.333.833-.833.833h-.833c-.5 0-.834-.333-.834-.833v-2.333c0-.5.334-.834.834-.834h.833c.5 0 .833.334.833.834v2.333zM13.208 17.375c0 .5-.333.833-.833.833h-.833c-.5 0-.834-.333-.834-.833V7.542c0-.5.334-.834.834-.834h.833c.5 0 .833.334.833.834v9.833zM18.208 17.375c0 .5-.333.833-.833.833h-.833c-.5 0-.834-.333-.834-.833v-5.667c0-.5.334-.833.834-.833h.833c.5 0 .833.333.833.833v5.667z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "storage-reports_svg__clip0_18_77793"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgStorageReports;